module.exports = __webpack_public_path__ + "img/carteirinhaGatoFrente_2.ffd32390.jpeg";